export default __webpack_public_path__ + "assets/images/d4a3104f70ae38440c79599ddf90ada0.png";